import classNames from "classnames";
import React from "react";
import { styled } from "@linaria/react";
import Tick from "@ui/Tick";
import Option from "@ui/Option";
import { color, fonts } from "@ui";
import type { ProjectRole } from "../../../api/useUser";

export type UserProjectRoleOption = Extract<
  ProjectRole,
  "PROJECT_MANAGER" | "PROJECT_READER" | "PROJECT_WRITER" | "PROJECT_SETUPER"
>;

export const AnimatedTick = styled(Tick)`
  @keyframes check {
    to {
      clip-path: inset(0);
    }
  }
  clip-path: inset(0 100% 0 0);
  animation: check 200ms ease forwards;
  margin-left: auto;
`;

const StyledOption = styled(Option)`
  height: initial;
  padding: 10px 16px;
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  &.disabled {
    opacity: 0.4;
  }
`;

const OptionTitle = styled.p`
  font: ${fonts.body1SemiBold};
  color: ${color.carbon900};
`;

const OptionDescription = styled.p`
  font: ${fonts.body2};
  font-weight: 500;
  color: ${color.carbon800};
  max-width: 190px;
  white-space: normal;
`;

export interface ProjectRoleOption {
  titleLabel: string;
  descriptionLabel: string;
  value: Exclude<UserProjectRoleOption, null>;
  disabled?: boolean;
}

function ProjectRolesOptions({
  options,
  currentSelection,
  onClick,
}: {
  options: ProjectRoleOption[];
  currentSelection: ProjectRole;
  onClick: (role: UserProjectRoleOption) => void;
}) {
  return (
    <>
      {options.map(option => (
        <StyledOption
          key={option.value}
          onClick={() => onClick(option.value)}
          disabled={option.disabled}
        >
          <ContentWrapper className={classNames({ disabled: option.disabled })}>
            <div>
              <OptionTitle>{option.titleLabel}</OptionTitle>
              <OptionDescription>{option.descriptionLabel}</OptionDescription>
            </div>
            {(currentSelection?.includes("MANAGER") && option.value === "PROJECT_MANAGER" && (
              <AnimatedTick />
            )) ||
              (currentSelection?.includes("READER") && option.value === "PROJECT_READER" && (
                <AnimatedTick />
              )) ||
              (currentSelection?.includes("SETUPER") && option.value === "PROJECT_SETUPER" && (
                <AnimatedTick />
              )) ||
              (currentSelection?.includes("WRITER") && option.value === "PROJECT_WRITER" && (
                <AnimatedTick />
              ))}
          </ContentWrapper>
        </StyledOption>
      ))}
    </>
  );
}

export default ProjectRolesOptions;
